module.exports = __webpack_public_path__ + "static/media/preset2.525e4027.svg";